import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment/moment';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { setOpenedMessage } from '../../../store/actionCreators/messages';

const MsgHeader = ({msg, clubId }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { param1, param2, text } = msg.content;

    const open = () => {
        dispatch(setOpenedMessage(msg));
    };

    const getOpenLink = () => {
        return clubId ? `/club/${clubId}/message/${msg._id}` : `/message/${msg._id}`;
    };

    return (
        <div>
            {!!msg && <Link className={`msg-item ${msg.status}`} onClick={() => open()} to={getOpenLink()}>
                <span className={`status ${msg.status}`}></span>
                <div className={`msg-container`}>
                    <span className={`title ${msg.status}`}>{t(msg.header)}</span>
                    <div className={`msg-content`}>{t(text, { messageParam1: param1 || null, messageParam2: param2 || null })}</div>
                </div>
                <span className={`date`}>{moment(msg.dateCreated).format('DD MMM YYYY')}</span>
            </Link>}
        </div>
    );
};

export default MsgHeader;
